import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20display%20scene%20with%20curated%20fashion%20accessories%20and%20sneakers%20arranged%20on%20warm%20cream%20textured%20surface%2C%20soft%20natural%20diffused%20window%20light%20creating%20gentle%20shadows%2C%20editorial%20product%20photography%20style%2C%20warm%20beige%20and%20cream%20tones%2C%20sophisticated%20clean%20composition%2C%20high-end%20catalog%20aesthetic%20with%20subtle%20shopping%20elements&width=1600&height=900&seq=hero-bg-kakobuy-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet Polska"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/18 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-16">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/20 backdrop-blur-sm rounded-full border border-background-50/30 mb-8">
          <i className="ri-sparkling-line text-secondary-300 text-sm"></i>
          <span className="text-xs text-background-50 font-medium">Aktualizacja 2026</span>
        </div>

        <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6">
          Kakobuy Spreadsheet Polska
          <br />
          <span className="text-primary-300">znajdź najlepsze produkty szybciej</span>
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          Kakobuy Spreadsheet to najprostszy sposób na odkrywanie najlepszych produktów, linków i kategorii.
          Sprawdź przygotowane listy, porównania oraz poradniki stworzone dla użytkowników z Polski.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2.5 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer no-underline"
          >
            <i className="ri-shopping-cart-line text-lg"></i>
            Buy It Now
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2.5 px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 rounded-full text-base font-semibold hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer border border-background-50/30 no-underline"
          >
            <i className="ri-external-link-line text-lg"></i>
            Kakobuy Spreadsheet
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-10 text-xs text-background-50/70">
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Aktualne listy produktów
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Poradniki zakupowe
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Kategorie produktów
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Bezpieczne korzystanie
          </span>
        </div>

        <div className="mt-16 flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/blog/kakobuy-spreadsheet-polska-przewodnik"
            className="inline-flex items-center gap-2 text-background-50/70 hover:text-background-50 text-sm transition-colors cursor-pointer no-underline"
          >
            <i className="ri-article-line"></i>
            Kompletny poradnik Kakobuy
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/blog/kakobuy-bezpieczenstwo"
            className="inline-flex items-center gap-2 text-background-50/70 hover:text-background-50 text-sm transition-colors cursor-pointer no-underline"
          >
            <i className="ri-shield-check-line"></i>
            Poradnik bezpieczeństwa
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}